<template>
  <div class="history-line-new">
    <!-- 桌面端展示 (大于767px) -->
    <div v-if="windowWidth > 767" class="desktop-container">
      
      <!-- 内容展示区域 (Swiper) -->
      <div class="content-swiper-wrapper">
        <swiper :options="swiperOption" ref="mySwiper" class="content-swiper">
          <swiper-slide v-for="(item, index) in historyText" :key="index">
            <div 
              class="history-card" 
              :class="{ 'active-card': index === activeIndex }"
              @click="handleCardClick(index)"
            >
              <!-- 顶部年份和线条 -->
              <div class="card-header">
                <div class="header-year">{{ item.times }}</div>
                <div class="header-line">
                  <!-- Progress bar for active slide -->
                  <div v-if="index === activeIndex" class="progress-bar" :style="{ width: currentProgress + '%' }"></div>
                </div>
              </div>
              
              <!-- 内容区域 -->
              <div class="card-content">
                <div class="content-year">{{ item.times }}年</div>
                <div class="works-list">
                  <div v-for="(work, wIndex) in item.works" :key="wIndex" class="work-item">
                    {{ work.work }}
                  </div>
                </div>
              </div>
            </div>
          </swiper-slide>
        </swiper>
        
        <!-- 底部切换按钮 (居中) -->
        <div class="swiper-nav-btns">
          <div class="nav-btn prev-btn" @click="slidePrev">
            <i class="arrow-left"></i>
          </div>
          <div class="nav-btn next-btn" @click="slideNext">
            <i class="arrow-right"></i>
          </div>
        </div>
      </div>
    </div>

    <!-- 移动端展示 (优化版，小于等于767px) -->
    <div v-else class="mobile-container">
      <ul class="mobile-timeline">
        <li v-for="(item, index) in historyText" :key="index" class="mobile-item">
          <div class="mobile-year-header">
            <span class="mobile-year-text">{{ item.times }}年</span>
          </div>
          <div class="mobile-content-body">
            <div v-for="(work, wIndex) in item.works" :key="wIndex" class="mobile-work-item">
              {{ work.work }}
            </div>
          </div>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
// 引入 Swiper 组件
import { swiper, swiperSlide } from "vue-awesome-swiper";
import "swiper/dist/css/swiper.css";

export default {
  name: "HistoryLineNew",
  components: {
    swiper,
    swiperSlide
  },
  props: {
    // 接收父组件传递的历史数据
    historyText: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      windowWidth: document.documentElement.clientWidth, // 窗口宽度，用于响应式判断
      activeIndex: 0, // 当前选中的索引
      currentProgress: 0, // 进度条当前进度
      animationFrameId: null, // requestAnimationFrame ID
      animationStartTime: null, // 动画开始时间
      animationDuration: 3000, // 动画持续时间，与 Swiper 自动播放延迟一致
      // Swiper 配置
      swiperOption: {
        speed: 800, // 切换速度
        slidesPerView: 4, // 每次显示4个
        spaceBetween: 10, // 间距
        slidesPerGroup: 1, // 每次滑动1个
        // loop: true, // 循环模式
        autoplay: false, // 禁用 Swiper 自身的自动播放，由进度条控制
        observer: true, // 监听DOM变化
        observeParents: true, // 监听父级变化
        grabCursor: true, // 手势形状
      }
    };
  },
  watch: {
    activeIndex(newIndex, oldIndex) {
      if (newIndex !== oldIndex) {
        this.stopProgressAnimation();
        this.startProgressAnimation();
      }
    }
  },
  mounted() {
    // 监听窗口大小变化
    window.addEventListener('resize', this.handleResize);
    
    // 监听 swiper 切换事件
    if (this.$refs.mySwiper && this.$refs.mySwiper.swiper) {
      const swiperInstance = this.$refs.mySwiper.swiper;
      swiperInstance.on('slideChange', () => {
        this.activeIndex = swiperInstance.activeIndex;
      });
    }
    this.startProgressAnimation(); // Start animation on mount
  },
  beforeDestroy() {
    // 销毁时移除监听
    window.removeEventListener('resize', this.handleResize);
    this.stopProgressAnimation(); // Stop animation on destroy
  },
  methods: {
    // 处理窗口大小变化
    handleResize() {
      this.windowWidth = document.documentElement.clientWidth;
    },
    // 上一张
    slidePrev() {
      if (this.activeIndex > 0) {
        this.activeIndex--;
        if (this.$refs.mySwiper && this.$refs.mySwiper.swiper) {
          this.$refs.mySwiper.swiper.slideTo(this.activeIndex);
        }
      }
    },
    // 下一张
    slideNext() {
      if (this.activeIndex < this.historyText.length - 1) {
        this.activeIndex++;
        if (this.$refs.mySwiper && this.$refs.mySwiper.swiper) {
          this.$refs.mySwiper.swiper.slideTo(this.activeIndex);
        }
      } else {
        // If it's the last slide, loop back to the first or stop
        this.activeIndex = 0; // Loop back to first
        if (this.$refs.mySwiper && this.$refs.mySwiper.swiper) {
          this.$refs.mySwiper.swiper.slideTo(this.activeIndex);
        }
      }
    },
    // 点击卡片切换
    handleCardClick(index) {
      this.activeIndex = index;
      if (this.$refs.mySwiper && this.$refs.mySwiper.swiper) {
        this.$refs.mySwiper.swiper.slideTo(index);
      }
    },
    startProgressAnimation() {
      this.stopProgressAnimation(); // Clear any existing animation
      this.currentProgress = 0;
      this.animationStartTime = performance.now();
      this.animationFrameId = requestAnimationFrame(this.animateLineProgress);
    },
    animateLineProgress(timestamp) {
      if (!this.animationStartTime) {
        this.animationStartTime = timestamp;
      }
      const elapsed = timestamp - this.animationStartTime;
      let progress = (elapsed / this.animationDuration) * 100;

      if (progress >= 100) {
        this.currentProgress = 100;
        this.stopProgressAnimation();
        // Trigger next slide after animation completes
        this.slideNext();
        // Start animation for the new slide immediately
        this.$nextTick(() => {
          this.startProgressAnimation();
        });
      } else {
        this.currentProgress = progress;
        this.animationFrameId = requestAnimationFrame(this.animateLineProgress);
      }
    },
    stopProgressAnimation() {
      if (this.animationFrameId) {
        cancelAnimationFrame(this.animationFrameId);
        this.animationFrameId = null;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
/* 容器样式 */
.history-line-new {
  width: 100%;
  background: #fff;
  padding: 50px 0;
}

/* 桌面端样式 */
.desktop-container {
  max-width: 1400px; /* 加宽容器以容纳4列 */
  margin: 0 auto;
  padding: 0 40px;
}

.content-swiper-wrapper {
  position: relative;
  padding-bottom: 80px; /* 底部留出按钮空间 */
}

.content-swiper {
  width: 100%;
  padding: 20px 0;
}

/* 卡片样式 */
.history-card {
  // padding: 0 20px;
  text-align: left; /* 左对齐 */
  cursor: pointer;
  transition: all 0.3s ease;
  outline: none; /* 防止点击时的焦点轮廓 */

  /* 悬停效果 & 激活状态 */
  &:hover, &.active-card {
    .header-year {
      color: #1570EF;
      font-weight: bold;
    }
    .header-line {
      // background: #1570EF; /* 移除此行，让 progress-bar 控制背景色 */
      height: 3px; /* 加粗线条 */
    }
    .content-year {
      color: #1570EF;
    }
  }
}

/* 头部：年份 + 线条 */
.card-header {
  margin-bottom: 20px;
  
  .header-year {
    font-size: 18px;
    color: #666;
    margin-bottom: 10px;
    transition: all 0.3s ease;
  }

  .header-line {
    width: 100%;
    height: 1px;
    background: #E0E0E0;
    transition: all 0.3s ease;
    position: relative;

    .progress-bar {
      position: absolute;
      top: 0;
      left: 0;
      height: 100%;
      background: #1570EF; /* Active color */
      transition: width 0.5s linear; /* Smooth progress update */
    }
  }
}

/* 内容部分 */
.card-content {
  .content-year {
    font-size: 24px;
    color: #333; /* 默认黑色，悬停变蓝 */
    font-weight: bold;
    margin-bottom: 15px;
    transition: all 0.3s ease;
  }

  .works-list {
    // width: 80%;
    .work-item {
      font-size: 14px;
      color: #5B728F;
      margin-bottom: 8px;
      line-height: 1.6;
      position: relative;
      padding-left: 0;
    }
  }
}

/* 底部切换按钮 (居中显示) */
.swiper-nav-btns {
  position: absolute;
  bottom: 0;
  left: 50%;
  transform: translateX(-50%);
  display: flex;
  gap: 30px; /* 按钮间距 */
  z-index: 10;

  .nav-btn {
    width: 50px;
    height: 50px;
    background: #fff;
    border-radius: 50%;
    box-shadow: 0 8px 16px 0 #1b75ed26;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    transition: all 0.3s ease;
    color: #1570EF;

    /* 悬停效果 */
    &:hover {
      background: #1570EF;
      color: #fff;
      transform: scale(1.1);
      box-shadow: 0 6px 15px rgba(24, 107, 179, 0.3);
    }

    /* 箭头图标 */
    .arrow-left, .arrow-right {
      display: inline-block;
      width: 10px;
      height: 10px;
      border-top: 2px solid currentColor;
      border-right: 2px solid currentColor;
    }

    .arrow-left {
      transform: rotate(-135deg);
      margin-left: 5px;
    }
    .arrow-right {
      transform: rotate(45deg);
      margin-right: 5px;
    }
  }
}

/* 移动端样式 */
.mobile-container {
  padding: 20px;
  
  .mobile-timeline {
    list-style: none;
    padding: 0;
    margin: 0;
    position: relative;
    
    /* 垂直连接线 */
    &::before {
      content: '';
      position: absolute;
      top: 15px;
      bottom: 0;
      left: 19px; /* 调整线条位置 */
      width: 2px;
      background: #e0e0e0;
    }

    .mobile-item {
      margin-bottom: 40px;
      position: relative;
      padding-left: 50px;

      /* 节点圆点 */
      &::before {
        content: '';
        position: absolute;
        left: 14px;
        top: 6px;
        width: 12px;
        height: 12px;
        border-radius: 50%;
        background: #fff;
        border: 3px solid #1570EF;
        z-index: 2;
      }

      .mobile-year-header {
        margin-bottom: 8px;
        .mobile-year-text {
          font-size: 20px;
          color: #1570EF;
          font-weight: bold;
        }
      }

      .mobile-content-body {
        .mobile-work-item {
          font-size: 14px;
          color: #5B728F;
          margin-bottom: 5px;
          line-height: 1.6;
        }
      }
    }
  }
}
</style>